// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class Size {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Size {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  width(): number {
    return this.bb!.readFloat32(this.bb_pos)
  }

  height(): number {
    return this.bb!.readFloat32(this.bb_pos + 4)
  }

  static sizeOf(): number {
    return 8
  }

  static createSize(builder: flatbuffers.Builder, width: number, height: number): flatbuffers.Offset {
    builder.prep(4, 8)
    builder.writeFloat32(height)
    builder.writeFloat32(width)
    return builder.offset()
  }
}
